import React, {Component} from 'react';
import CardWidget from "../card-widget/CardWidget";
import CardWidgetErrorsContainer from "../card-widget/CardWidgetErrorsContainer";
import {RouteConstants} from "../route/services/RouteConstants";

class PasswordResetError extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  goNext = () => {
    this.props.history.push(RouteConstants.LOGIN);
  };

  getCardContent = () => {
    return (
        <div>
          <CardWidgetErrorsContainer errorMessage="password_reset.invalid_code"/>
        </div>
    )
  };

  render() {
    return (
        <CardWidget getCardContent={this.getCardContent}
                    submitButtonAction={this.goNext}
                    submitButtonText="forgotpassword.next"/>
    )
  };
}

export default PasswordResetError;